module.exports = __webpack_public_path__ + "media/images/items/thumbnail-4-60586abb7dbfa8a938f2801724c58982.jpg";